export const getQueryParams = ( url: string, param: string ) => {
    let href = url;
    let reg = new RegExp( '[?&]' + param + '=([^&#]*)', 'i' );
    let queryString = reg.exec(href);
    return queryString ? queryString[1] : null;
};